export default __webpack_public_path__ + "static/media/Ballroll_00036.f4221c25.png";